import { defineComponent, ref } from 'vue';
import moment from 'moment';
import { useOTP } from '@/use/otp';
import { ALERT } from '@/constants/icons';
export default defineComponent({
  props: {
    headerText: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: String,
      default: null
    }
  },
  setup: (_props, {
    emit
  }) => {
    const otpModelRef = ref(null);
    const phoneNumber = ref(null);
    const optRequested = ref(false);
    const validPhoneNumber = ref(false);
    const validOtp = ref(false);
    const otpValue = ref(null);
    const disableResend = ref(true);
    const {
      startTimer,
      resetTimer,
      timerCount,
      timerEnable
    } = useOTP();
    const otpRef = ref(null);
    const resetValues = () => {
      var _otpRef$value;
      optRequested.value = false;
      otpValue.value = null;
      validPhoneNumber.value = false;
      validOtp.value = false;
      otpRef === null || otpRef === void 0 ? void 0 : (_otpRef$value = otpRef.value) === null || _otpRef$value === void 0 ? void 0 : _otpRef$value.resetOtp();
      resetTimer();
      emit('reset-values');
    };
    const show = () => {
      otpModelRef.value.show();
    };
    const close = () => {
      otpModelRef.value.close();
    };
    const validateOtp = value => {
      otpValue.value = value;
      emit('on-complete', otpValue.value);
    };
    const onChangeOtp = value => {
      validOtp.value = value.length === 6;
    };
    return {
      otpModelRef,
      phoneNumber,
      validPhoneNumber,
      optRequested,
      validOtp,
      validateOtp,
      onChangeOtp,
      resetValues,
      disableResend,
      timerEnable,
      timerCount,
      moment,
      show,
      close,
      startTimer,
      ALERT,
      otpRef
    };
  }
});